import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, ArrowRight } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { API_URL } from '../config/api';

// Mock data - removed, using empty array instead
const mockPosts = [];

const BlogPage = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Fetch blog posts from API with aggressive cache busting
        const fetchPosts = async () => {
            try {
                const timestamp = Date.now();
                const random = Math.random().toString(36).substring(7);
                const cacheBuster = `?_=${timestamp}&r=${random}`;
                
                console.log('📝 Fetching blog posts from:', `${API_URL}${cacheBuster}`);
                
                const response = await fetch(`${API_URL}${cacheBuster}`, {
                    method: 'GET',
                    headers: {
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        'Pragma': 'no-cache',
                        'Expires': '0',
                        'If-Modified-Since': 'Wed, 21 Oct 2015 07:28:00 GMT'
                    },
                    mode: 'cors',
                    cache: 'no-store',
                    redirect: 'follow'
                });
                
                console.log('Response status:', response.status);
                
                if (!response.ok) {
                    throw new Error('API error: ' + response.status);
                }
                
                const data = await response.json();
                console.log('Received posts:', data);
                
                // Filter only published posts
                const publishedPosts = Array.isArray(data)
                    ? data.filter(post => post.status === 'published')
                    : [];
                
                console.log('Published posts:', publishedPosts.length);
                setPosts(publishedPosts.length > 0 ? publishedPosts : []);
                
                if (publishedPosts.length === 0) {
                    console.warn('⚠️ No published posts found in database');
                }
            } catch (err) {
                console.error('Blog fetch error:', err);
                setPosts([]);
            } finally {
                setLoading(false);
            }
        };
        fetchPosts();
    }, []);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('tr-TR', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    };

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-white">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-white">
            <Header />
            <div className="container mx-auto px-4 py-12">
                <div className="text-center mb-12">
                    <h1 className="text-4xl font-bold text-gray-800 mb-4">Blog</h1>
                    <p className="text-gray-600 max-w-2xl mx-auto">
                        Araç far ve stop lambası hakkında güncel haberler, ipuçları ve bilgiler
                    </p>
                </div>

                {posts.length === 0 && !loading ? (
                    <div className="text-center py-12">
                        <div className="text-6xl mb-4">📝</div>
                        <h3 className="text-2xl font-semibold text-gray-700 mb-2">Henüz Blog Yazısı Yok</h3>
                        <p className="text-gray-500 mb-6">İlk blog yazınızı admin panelinden ekleyin!</p>
                        <a
                            href="/admin"
                            className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors"
                        >
                            Admin Paneline Git
                        </a>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {posts.map((post) => (
                            <article
                                key={post.id}
                                className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300 border border-gray-100"
                            >
                                {post.image && (
                                    <div className="h-48 overflow-hidden">
                                        <img
                                            src={post.image}
                                            alt={post.title}
                                            className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                                        />
                                    </div>
                                )}

                                <div className="p-6">
                                    <div className="flex items-center text-gray-500 text-sm mb-3">
                                        <Calendar size={16} className="mr-2" />
                                        {formatDate(post.created_at)}
                                    </div>

                                    <h2 className="text-xl font-bold text-gray-800 mb-3 hover:text-blue-600 transition-colors">
                                        <Link to={`/blog/${post.slug}`}>
                                            {post.title}
                                        </Link>
                                    </h2>

                                    <p className="text-gray-600 mb-4 line-clamp-3">
                                        {post.excerpt}
                                    </p>

                                    <Link
                                        to={`/blog/${post.slug}`}
                                        className="inline-flex items-center text-blue-600 font-semibold hover:text-blue-700 transition-colors"
                                    >
                                        Devamını Oku
                                        <ArrowRight size={18} className="ml-2" />
                                    </Link>
                                </div>
                            </article>
                        ))}
                    </div>
                )}
            </div>
            <Footer />
        </div>
    );
};

export default BlogPage;
